import React from 'react'
import { 
    Button, 
    Table, 
    Row, 
    Divider, 
    Popconfirm, 
    Modal, 
    Input, 
    Progress,
    message,
    Select,
} from 'antd'
import { firestore, firStorage } from '../../../service/firebase'
import './PersonalTaste.scss'

const { TextArea } = Input
const Option = Select.Option


export default class PersonalTaste extends React.Component {
    
    columns = [
        { title: "Logo", dataIndex: 'image', key: 'image', render: images => {
            if(images) {
                return <img src={images[0]} style={{maxWidth: 50, maxHeight: 50}} alt="IMG-LOGO" />
            } else {
                return <img src={require('../../../assets/img_placeholder.png')} style={{maxWidth: 50, maxHeight: 50}} alt="IMG-LOGO" />
            }
        } },
        { title: "Title", dataIndex: 'title', key: 'title' },
        { title: "Address", dataIndex: 'address', key: 'address' },
        { title: "Category", dataIndex: 'category', key: 'category' },
        { title: "Link", dataIndex: 'link', key: 'link', render: url => {
            return <a href={url}>{url}</a>
        } },
        { title: 'Actions', render: (item) => {
            return (
                <span>
                    {/* <a onClick={() => this.handleEdit(item)}>Edit</a> */}
                    <Divider type="vertical" />
                    <Popconfirm title="Are you sure delete?" onConfirm={() => this.handleDelete(item)} okText="Yes" cancelText="No">
                        <a>Delete</a>
                    </Popconfirm>
                </span>
            )
        }}
    ]

    dataList = []

    categories = []
    
    state = {
        showModal: false,
        uploadState: 0,
        downloadURL: '',
    }

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadCategories()
        this.loadEvents()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadEvents() {

        firestore.collection('taste')
        .onSnapshot(snapshot => {
    
            snapshot.docChanges().forEach(change => {
    
                let data = change.doc.data()
    
                if(change.type === 'added') {

                    if(data['category']) {
                        this.dataList.push(data)
                    }

                } else if(change.type === 'modified') {

                    this.dataList = this.dataList.map(item => {
                        if(item.id === data.id) {
                            return data
                        } else {
                            return item
                        }
                    })

                } else {

                    for(let i = 0; i < this.dataList.length; i++) {
                        let item = this.dataList[i]
                        if(item.id === data.id) {
                            this.dataList.splice(i, 1)
                            break
                        }
                    }

                }
            })
    
            this.forceUpdate()
        })
    
    }

    loadCategories() {
        firestore.collection('TasteCategory')
        .onSnapshot(snapshot => {
    
            snapshot.docChanges().forEach(change => {
    
                let data = change.doc.data()
    
                if(change.type === 'added') {

                    this.categories.push(data)

                } else if(change.type === 'modified') {

                    this.categories = this.categories.map(item => {
                        if(item.id === data.id) {
                            return data
                        } else {
                            return item
                        }
                    })

                } else {

                    for(let i = 0; i < this.categories.length; i++) {
                        let item = this.categories[i]
                        if(item.id === data.id) {
                            this.categories.splice(i, 1)
                            break
                        }
                    }

                }
            })
    
            this.forceUpdate()
        })
    }


    /*--------------------------------------------------------------*/
    /* Format functions */
    /*--------------------------------------------------------------*/

    dateFormat(date) {
        let year = this.numberFormat(date.getFullYear())
        let month = this.numberFormat(date.getMonth())
        let day = this.numberFormat(date.getDate())
        let hr = this.numberFormat(date.getHours())
        let min = this.numberFormat(date.getMinutes())

        return year + '/' + month + '/' + day + ' ' + hr + ':' + min
    }

    numberFormat(num) {
        return num > 9 ? num + '' : '0' + num
    }

    dateDetail(date) {
        if(date) {
            let dateStr = this.dateFormat(date.toDate())
            return (<div>{dateStr}</div>)
        } else {
            return (<div> - </div>)
        }
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    handleAdd() {
        this.eventEdit = false
        this.setState({
            id: '',
            logo: null,
            title: '',
            description: '',
            address: '',
            url: '',
            facebook: null,
            phone: null,
            banner: null,
            showModal: true,
            uploadState: 0,
        })
    }

    handleEdit(item) {
        this.eventEdit = true
        let state = this.state

        let newState = Object.assign(state, item, {
            showModal: true,
            uploadState: 2,
        })

        console.log(newState)
        this.setState(newState)
    }

    handleChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }
    
    handleDelete(item) {
        firestore.collection('taste').doc(item.id).delete();
    }

    handleOK() {
        let state = this.state

        let id = state.id
        let ref

        if(!this.eventEdit) {
            ref = firestore.collection('taste').doc()
            id = ref.id
        } else {
            ref = firestore.collection('taste').doc(id)
        }

        let object = {
            id,
            title: state.title ? state.title : '',
            category: state.category ? state.category : '',
            subCategory: state.subCategory ? state.subCategory : '',
            description: state.description ? state.description : '',
            address: state.address ? state.address : '',
            banner: state.banner ? state.banner : [],
            image: state.logo ? [state.logo] : '',
            link: state.url ? this.link(state.url) : '',
            facebook: state.facebook ? this.link(state.facebook) : '',
            phone: state.phone ? state.phone : '',
            order: this.dataList.length,
        }

        console.log(object)

        ref.set(object)
        this.setState({showModal: false})
    }

    link(text) {
        if(text.substring(0, 4) === 'http') {
            return text
        } else {
            return 'http://' + text
        }
    }

    handleClose() {
        this.setState({showModal: false})
    }


    /*-----------------Upload Image-------------------*/

    handleUpload(input) {
        input.click();
    }

    onChangeFile(evt, type) {
        let orgName = evt.target.files[0].name;
        let key = Date.now();
        let fileName = this.page + "_" + key + "." + orgName.substring(orgName.length - 3);
        let path = '/' + this.page + '/' + fileName;
        this.uploadFile(evt.target.files[0], path, type);
    }
    
    uploadFile(file, path, type) {
        if(this.state.uploadState === 1) {
            return;
        }

        this.setState({uploadState: 1});

        var uploadTask = firStorage.ref().child(path).put(file);
        uploadTask.on('state_changed', (snapshot) => {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.setState({uploadProgress: progress});
            console.log('Upload is ' + progress + '% done');
        }, (error) => {
            this.setState({uploadState: 0});
            message.error("Failed on uploading image! Try again please!");
        }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log('File available at', downloadURL);
                this.setState({
                    uploadState: 2,
                    logo: downloadURL
                });
            });
        });
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/

    renderCellDetail(row) {
        console.log(row)

        return(
            <Row className="cell">
                <div className="img">
                {
                    row.image ? 
                        <img src={row.image[0]} alt="IMG-LOGO" /> :
                        <img src={require('../../../assets/img_placeholder.png')} alt="IMG-LOGO" />
                }
                </div>

                <div className="content">
                    <div className="content-row"><div className="caption"><b>Title :</b></div>{row.title}</div>
                    <div className="content-row"><div className="caption"><b>Address :</b></div> {row.address ? row.address : '-'}</div>
                    <div className="content-row"><div className="caption"><b>Link :</b></div> {row.link ? <a href={row.link}>{row.link}</a> : '-'}</div>
                    <div className="content-row"><div className="caption"><b>Map Link :</b></div> {row.map ? <a href={row.map}>{row.map}</a> : '-'}</div>
                    <div className="content-row"><div className="caption"><b>Email :</b></div> {row.email ? row.email : '-'}</div>
                    <div className="content-row"><div className="caption"><b>Phone :</b></div> {row.phone ? row.phone : '-'}</div>
                    <div className="content-row"><div className="caption"><b>Category :</b></div> {row.category ? row.category : '-'} {row.subCategory && row.subCategory.length > 0 && '(' + row.subCategory + ')'}</div>
                    <div style={{margin: '20px 5px 5px 5px', display: 'flex'}}><div className="caption"><b>Description :</b></div></div>
                    <div style={{margin: 5, marginLeft: 100}}>{row.description}</div>
                </div>
            </Row>
        )
    }

    
    render() {

        return (
            <div className="personal-taste">

                <Row style={{textAlign: 'right', padding: 10}}>
                    <Button type="primary" icon="plus" onClick={() => this.handleAdd()}>Personal Taste</Button>
                </Row>

                <Table 
                    style={{margin: 10, background: 'white'}}
                    columns={this.columns}
                    expandedRowRender={record => this.renderCellDetail(record)} 
                    rowKey={record => record.id}
                    dataSource={this.dataList} />

                
                <Modal
                    title={this.eventEdit ? 'Edit Personal Taste' : "Add Personal Taste"}
                    visible={this.state.showModal}
                    onOk={() => this.handleOK()}
                    onCancel={() => this.handleClose()}>

                    <Row className="input-row">
                        <div className="input-label">Title</div>
                        <Input value={this.state.title} onChange={evt => this.handleChange('title', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Address</div>
                        <Input value={this.state.address} onChange={evt => this.handleChange('address', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Link</div>
                        <Input value={this.state.url} onChange={evt => this.handleChange('url', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Facebook</div>
                        <Input value={this.state.facebook} onChange={evt => this.handleChange('facebook', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Phone</div>
                        <Input value={this.state.phone} onChange={evt => this.handleChange('phone', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Category</div>
                        <Select defaultValue="Select Category" onChange={value => this.handleChange('category', value)}>
                        { this.categories.map((category, idx) => <Option key={idx} value={category.id}>{category.title}</Option>) }
                        </Select>
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Sub Category</div>
                        <Input value={this.state.subCategory} onChange={evt => this.handleChange('subCategory', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Description</div>
                        <TextArea autosize={{minRows: 3, maxRows: 9}} value={this.state.description} onChange={evt => this.handleChange('description', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Logo Image</div>
                        <div style={{cursor: 'pointer'}} onClick={() => this.handleUpload(this.logoInput)}>
                        {
                            this.state.uploadState === 0 ?
                                <div className="logo-placeholder">Logo</div> :
                            this.state.uploadState === 1 ?
                                <div style={{margin: 20}}>
                                    <Progress type="circle" percent={this.state.uploadProgress ? Number(this.state.uploadProgress.toFixed(2)) : 0} />
                                </div> :
                                <div className="logo-img">
                                    <img src={this.state.logo} alt="IMG-LOGO" />
                                </div>
                        }
                        </div>
                    
                        <input type="file" className="file-input"
                            ref={input => this.logoInput = input}
                            onChange={evt => this.onChangeFile(evt)}
                            accept="image/x-png,image/gif,image/jpeg" />

                    </Row>

                </Modal>

            </div>
        )
    }
}
